import { Col, Form, Input, Row } from 'antd';
import { __SocialMedias } from './socialMedia.data';
import { useEffect } from 'react';
import { useRealTimeState, useThen } from 'scripts';

type socialKeys = (typeof __SocialMedias)[number]['name'];
export default function SocialMediaComp(props: { initialData?: { [key in socialKeys]?: string } }) {
    return (
        <>
            <p className="t-h2 t-500 t-d-gray2 mb-3">شبکه‌های اجتماعی</p>
            <Row gutter={24}>
                {__SocialMedias.map((item, index) => (
                    <Col key={index} lg={{ span: 12 }} md={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item
                            label={item.label}
                            name={['socials', `${item.name}`]}
                            initialValue={props.initialData?.[item.name]}
                        >
                            <CustomLink className="ltr-i ltr-tree-i t-tree-left-i t-left-i" prefix={item.link} />
                        </Form.Item>
                    </Col>
                ))}
            </Row>
        </>
    );
}

const CustomLink = (props: {
    className?: string;
    prefix?: string;
    value?: string;
    onChange?: (e?: string) => void;
}) => {
    const value = useRealTimeState<string | undefined>(props.value?.length ? props.value : undefined);

    useEffect(() => {
        if (props.value !== value.get()) value.set(props.value?.length ? props.value : undefined);
    }, [props.value]);

    useThen(() => {
        if (value.get() !== props.value) props.onChange?.(value.get());
    }, [value.dep]);

    return (
        <Input
            className={props.className}
            prefix={props.prefix}
            value={props.prefix?.length ? value.dep?.replace(props.prefix, '') : value.dep}
            onChange={(e) => {
                const val = e.target.value;
                const pre = props.prefix ?? '';
                value.set(val?.length ? pre + val : undefined);
            }}
        />
    );
};
